module.exports = __webpack_public_path__ + "img/arrow-pointer.17aaacee.svg";